/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(function () {
  if($('.product-form__tabs').length){
    $('.Collapsible__Button').click(function(){
      $(this).toggleClass('is-show');
      $(this).parent().find('.Collapsible__Inner').slideToggle();
    })
  }

  const regionSelects = document.querySelectorAll(".region-select");
  regionSelects.forEach(function(select) {
    select.addEventListener("change", function() {
      window.location.href = this.value;
    });
  });

  if($('.c-mobile__tab').length){
    $('.c-mobile__tab').click(function(){
      $('.c-mobile__tab').removeClass('is-active');
      $(this).addClass('is-active');
    })

    $('.c-header__icon--burger button').click(function(){
      $(this).find('.c-burger').toggleClass('is-active');
      $('#mobile-menu-drawer').toggleClass('is-active');
      $('.mobile-region').toggleClass('is-show');

      if( $('#mobile-menu-drawer').hasClass('is-active')){
        $('body').addClass('lock-all');
      }
      else{
        $('body').removeClass('lock-all');
      }
    })

    $('button.c-mobile__link').click(function(e){
      e.preventDefault();
      $(this).siblings().addClass('is-active');
    })

    $('.mobile-tab__collapsible2 h4').click(function(e){
      e.preventDefault();
      $(this).parent().removeClass('is-active');
    })
    
  }

  if ($('.template-cart').length) {
    if($('.line-item').length == 0){
         localStorage.removeItem('lastSelected');
    }
    var lstCartItem = $('.line-item');
    var lstGiftBoxID = ['46894413283608', '46894405386520', '46894380515608', '47025576870168', '46936298815768'];
    var lstShoppingBagID = ['49211923562776', '49211923792152', '49211924578584'];
    var lstId = [];
    for(let i = 0; i < lstCartItem.length; i++){
        var id = $(lstCartItem[i]).find('input[name="cartItemID"]').val();
        lstId.push(id);
    }
  
    if(findCommonElements(lstId, lstGiftBoxID)){
        var productID = lstId.filter(function(val) {
            return lstGiftBoxID.indexOf(val) != -1;
        });
        localStorage.setItem('lastSelected', productID);
        $('#effectiveAppsEGW').prop('checked', true);
        $('.Cart__GiftWrappingSelectBox').addClass('c-active');
        $('.slGiftSizeClass').val(localStorage.getItem('lastSelected'));
    }
    if(findCommonElements(lstId, lstShoppingBagID)){
        var productID = lstId.filter(function(val) {
            return lstShoppingBagID.indexOf(val) != -1;
        });
        localStorage.setItem('lastSelected', productID);
        $('#effectiveAppsESB').prop('checked', true);
        $('.Cart__ShoppingBagSelectBox').addClass('c-active');
        $('.slShoppingBagSizeClass').val(localStorage.getItem('lastSelected'));
    }
    if(!findCommonElements(lstId, lstGiftBoxID) && !findCommonElements(lstId, lstShoppingBagID)){
        localStorage.removeItem('lastSelected');
    }
    //if(localStorage.getItem('lastSelected')){
    //   $('#effectiveAppsEGW').prop('checked', true);
    //   $('.Cart__GiftWrappingSelectBox').addClass('c-active');
    //   $('.slGiftSizeClass').val(localStorage.getItem('lastSelected'));
    //}
    function findCommonElements(arr1, arr2) {
          return arr1.some(item => arr2.includes(item))
      }
    function addItemToCart(productID){
      if (productID == 'サイズを指定') {
        return;
      }
      let addData = {
        'id': productID,
        'quantity': 1
      };
      fetch('/cart/add.js', {
        body: JSON.stringify(addData),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
        },
        method: 'POST'
      }).then(function(response) {
        localStorage.setItem('lastSelected', productID);
        // $('form.cart__recap').submit();
        location.reload();
        return response.json();
      }).then(function(json) {
        /* we have JSON */
        localStorage.setItem('lastSelected', productID);
        // $('form.cart__recap').submit();
        location.reload();
      }).catch(function(err) {
        /* uh oh, we have error. */
        localStorage.removeItem('lastSelected');
        console.error(err);
        return false;
      });
     }
    $('.line-item__remove-button').click(function(){
        var id = $(this).parents('.line-item').find('input[name="cartItemID"]').val();
        if(id == localStorage.getItem('lastSelected')){
            localStorage.removeItem('lastSelected');
        }
    })
    $('.Cart__GiftWrappingCheckBox .checkmark').click(function(){
         $('.Cart__GiftWrappingSelectBox').toggleClass('c-active');
    })
    $('.Cart__ShoppingBagCheckBox .checkmark').click(function(){
         $('.Cart__ShoppingBagSelectBox').toggleClass('c-active');
    })
    $('.cart__checkout-button').click(function(){
         if($('.Cart__GiftWrappingSelectBox.c-active').length == 0 && $('.Cart__ShoppingBagSelectBox.c-active').length == 0){
             return true;
         }else if($('.Cart__GiftWrappingSelectBox.c-active').length == 1){
             var $select = $("#slGiftSizeID");
             if( $select.val() == 'サイズを指定' ){
                 $('.Cart__GiftWrappingSelectError').addClass('c-show');
                 return false;
             }
             else{
                 return true;
             }
         }else if($('.Cart__ShoppingBagSelectBox.c-active').length == 1){
             var $select = $("#slShoppingBagSizeID");
             if( $select.val() == 'サイズを指定' ){
                 $('.Cart__ShoppingBagSelectError').addClass('c-show');
                 return false;
             }
             else{
                 return true;
             }
         }
    })
    $('#slGiftSizeID').change(function(){
       var productID = $('#slGiftSizeID').val();
       var lastSelectedId = localStorage.getItem('lastSelected');
  
       // if(lastSelectedId && productID != lastSelectedId){
       //  $.ajax({
       //      url: `/cart/change?id=${lastSelectedId}&quantity=0`,
       //      type: "POST",
       //      async: false,
       //      // contentType: 'application/json; charset=utf-8',
       //      success: function (response) {
       //          addItemToCart(productID);
       //      },
       //      error: function (err) {
       //          console.error(err);
       //          return false;
       //      }
       //  });
       // }
       // else{
         addItemToCart(productID)
       // }
    })
    $('#slShoppingBagSizeID').change(function(){
       var productID = $('#slShoppingBagSizeID').val();
       var lastSelectedId = localStorage.getItem('lastSelected');
       addItemToCart(productID)
    })
  }

  $(window).scroll(function () {
    if ($(window).scrollTop() > $('.announcement-bar').height()){
      $('.header').addClass('is-fixed');
      if($('#newsletter-popup').length){
        $('#newsletter-popup').addClass('header-is-fixed');
      }
    }
    else{
      $('.header').removeClass('is-fixed');
      if($('#newsletter-popup').length){
        $('#newsletter-popup').removeClass('header-is-fixed');
      }
    }
  });

  if($(".template-collection .shopify-section--featured-collections").length > 0){
    const intervalIssetBoost = setInterval(checkIssetBoost, 500);
    function checkIssetBoost() {
      if($(".boost-sd__product-list").length > 0){
        clearInterval(intervalIssetBoost);
        setTimeout(function(){$(".template-collection .shopify-section--featured-collections").addClass("is-active");}, 1500);
      }
    }
  }

  if ($(".template-register").length > 0) {
    let checkExistDate = setInterval(function () {
      let $item = $('.cf-app__field input[type="date"]');
      if ($item.length) {
        clearInterval(checkExistDate);
        $item.each(function(){
            var input = $(this);
            var id = input.attr('id');
            if (!id){
                id='RandomGeneratedId_'+Math.random().toString(36).substring(7);
                input.attr('id',id);
            }
            var placeholder = '生年月日';
            if (placeholder){
                $('head').append('<style> #'+id+':before{ content:"'+placeholder+'"; width:100%; } #'+id+':focus:before,#'+id+'.not_empty:before{ content:none }</style>');
            }
            input.on('change keyup',function(){
                if ($(this).val()){
                    $(this).addClass('not_empty')
                }else{
                    $(this).removeClass('not_empty')
                }
                return false;
            });
        });
      }
    }, 100); // check every 100ms
  }
  
})

